import * as React from "react";
import XDiv from "../../core/XDiv";
import { COMPONENT_READABLE_NAME } from "../../../utils/constants/common/componentName";

import { Breadcrumbs, Typography } from "@mui/material";
import { TUseXElement } from "../../../hooks/useXElement";

export const XGUIHeaderBreadCrumb: React.FC<{
  selectedElement: TUseXElement<any>;
}> = ({ selectedElement }) => {
  const hierachy = (selectedElement.hierachy ?? "").split("-");

  return (
    <XDiv className="XGUI-Header-Breadcrumb">
      <Breadcrumbs maxItems={3}>
        {hierachy.map((item, i) => {
          return (
            <Typography
              variant="overline"
              color="white"
              sx={{ fontSize: 10, letterSpacing: "0.05em" }}
              key={i.toString()}
            >
              {COMPONENT_READABLE_NAME[item]}
            </Typography>
          );
        })}
      </Breadcrumbs>
    </XDiv>
  );
};
